<template>
    <div v-bind:class="className">
        <label class="control-label"> {{item.label}} </label>
        <select class="form-control margin-bottom" v-bind:name="item.name" v-on:input="update" v-bind:disabled="item.disabled">
            <option v-if="item.value!==''" value="">{{item.placeholder}}</option>
            <option v-else value="" selected>{{item.placeholder}}</option>
            <option v-for="option in item.select_options" v-if="item.value!==option.value"  v-bind:value="option.value">{{option.text}}</option>
            <option v-else v-bind:value="option.value"  selected>{{option.text}}</option>
        </select>
        <div v-for="error in item.errors" v-bind:class="{'margin-left': item.type=='checkbox'}" class="to-up" id="errors">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default{
    name: 'emt-select',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function (event) {
            var self = this
            self.item.value = event.target.value
            self.$emit('change')
        }
    }
}
</script>



// WEBPACK FOOTER //
// emt-select.vue?bfcdc28e